<template>
  <section class="monthly-car-renewal">
    <section class="go-back" @click="onGoBackbtn">&lt;返回</section>
    <!-- 中部：可滚动正文 -->
    <section class="monthly-car-renewal-body">
      <section class="monthly-car-renewal-content">
      <!-- 需求1：已有会员卡信息展示 -->
      <section v-if="memberCard.plateNumber" class="renewal-card member-card-info">
        <div class="renewal-card-title">会员卡信息</div>
        <ul class="renewal-card-grid">
          <li>
            <span class="renewal-card-label">会员卡车辆</span>
            <span class="renewal-card-value">{{ memberCard.plateNumber || "—" }}</span>
          </li>
          <li>
            <span class="renewal-card-label">车主姓名</span>
            <span class="renewal-card-value">{{ memberCard.userName || "—" }}</span>
          </li>
          <li>
            <span class="renewal-card-label">联系手机</span>
            <span class="renewal-card-value">{{ memberCard.phone || "—" }}</span>
          </li>
          <li>
            <span class="renewal-card-label">会员卡名称</span>
            <span class="renewal-card-value">{{ memberCard.chargeName || "—" }}</span>
          </li>
          <li>
            <span class="renewal-card-label">开始时间</span>
            <span class="renewal-card-value">{{ memberCard.startDate || "—" }}</span>
          </li>
          <li>
            <span class="renewal-card-label">结束时间</span>
            <span class="renewal-card-value">{{ memberCard.endDate || "—" }}</span>
          </li>
        </ul>
      </section>
      <el-form
        class="monthly-car-renewal-form"
        ref="rentMonthForm"
        :model="monthlyFormOrder"
        label-width="80px"
        :rules="rentMonthRules"
      >
        <el-form-item label="续费日期" prop="openDate" class="reset-input">
          <el-date-picker
            v-model="monthlyFormOrder.openDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="续费月数" prop="openMonth">
          <el-input v-model.number="monthlyFormOrder.openMonth"></el-input>
        </el-form-item>
        <el-form-item label="收费规则" prop="openCharge" class="reset-input">
          <el-select
            clearable
            v-model="monthlyFormOrder.openCharge"
            placeholder="请选择"
          >
            <el-option
              v-for="item in allMonthlyChargeRuleData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="道路名称" prop="parkings" class="reset-input">
          <el-select
            multiple
            clearable
            v-model="monthlyFormOrder.parkings"
            placeholder="请选择"
          >
            <el-option
              v-for="item in parkingsDataByProperty"
              :key="item.parkingId"
              :label="item.parkingName"
              :value="item.parkingId"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <!-- 需求2：选中规则后展示规则内容 -->
      <section v-if="currentChargeRule" class="renewal-card charge-rule-info">
        <div class="renewal-card-title">收费规则</div>
        <ul class="renewal-card-grid">
          <li>
            <span class="renewal-card-label">会员卡名称</span>
            <span class="renewal-card-value">{{ currentChargeRule.name || "—" }}</span>
          </li>
          <li>
            <span class="renewal-card-label">卡类型</span>
            <span class="renewal-card-value">{{ formatUnitType(currentChargeRule.unitType) }}</span>
          </li>
          <li>
            <span class="renewal-card-label">单价</span>
            <span class="renewal-card-value">{{ currentChargeRule.amount }} 元/月</span>
          </li>
          <li>
            <span class="renewal-card-label">适用车场</span>
            <span class="renewal-card-value">{{ currentChargeRule.parkingNames || "—" }}</span>
          </li>
          <li class="renewal-card-full">
            <span class="renewal-card-label">卡片说明</span>
            <span class="renewal-card-value">{{ currentChargeRule.instruction || "—" }}</span>
          </li>
        </ul>
      </section>
      </section>
    </section>
    <!-- 底部：固定操作栏（应缴金额 + 付款按钮） -->
    <section class="renewal-footer">
      <!-- 需求3：应缴金额实时展示 -->
      <section v-if="renewMoney !== null" class="renew-money">
        <span class="renew-money-label">应缴金额</span>
        <span class="renew-money-value">￥{{ renewMoney.toFixed(2) }}</span>
      </section>
      <section class="buttons">
        <el-button
          class="cash-button"
          type="primary"
          :loading="submitting"
          :disabled="submitting"
          @click="onCashBtn"
          >现金付款</el-button
        >
        <el-button
          class="qrcode-button"
          type="primary"
          :loading="submitting"
          :disabled="submitting"
          @click="onQrcodeBtn"
          >扫码付款</el-button
        >
      </section>
    </section>
    <!--付款二维码-->
    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        title="扫码付款"
        :visible.sync="photoDialogVisible"
        width="400px"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <div id="qrcode"></div>
        <div class="qrcode-money">应缴金额：{{ monthlyMoney.toFixed(2) }}元</div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { ref, computed, defineComponent } from "@vue/composition-api";


import websocket from "../../../helper/websocket";
import { monthlyUserAddOrEdit, allMonthlyChargeRule } from "@/api/url";
// interface MonthlyOrder{
// openDate:String,
// openMonth:Number,
// openCharge:String,
// parkings:String[],

// }

import QRCode from "qrcodejs2"; // 引入qrcode
const currency=require('currency.js')
export default defineComponent({
  name:'monthly-car-renewal',
  created() {
    this.recordId = this.$route.query.recordId;
    this.road = this.$route.query.road;
    // 会员卡信息：入口页（monthlyCar.vue）随 query 传入，未传时整卡隐藏
    this.memberCard = {
      plateNumber: this.$route.query.plateNumber || "",
      userName: this.$route.query.userName || "",
      phone: this.$route.query.phone || "",
      chargeName: this.$route.query.chargeName || "",
      startDate: this.$route.query.startDate || "",
      endDate: this.$route.query.endDate || "",
    };
  },
  mounted() {
    // road 是入口（monthlyCar.vue）传入的 scope.row.parentId，纯 ID，直接透传即可
    this.getAllMonthlyChargeRule(this.road);
    websocket.websocketListener((msg) => {
   
  
     
       if(msg.type==='webPay'){
        if(msg.message==='success'){
      this.photoDialogVisible=false;
      this.$notify({
         type: "success",
         title: '续费成功',
         message: `金额：${msg.money}`,
          position: "top-right",
       
        });
        return;
    }else{
      this.$notify({
          type: "warning",
          title: '续费失败',
          message: msg.message || '支付失败',
          position: "top-right",
       
        });
        return;
    }
        
       }
      
    });
  },
 
  setup() {
   
    const recordId = ref("");
    const photoDialogVisible = ref(false);
    const allMonthlyChargeRuleData = ref([]);
    const parkingsDataByProperty = ref([]);
    const monthlyMoney = ref(0.0);
    const submitting = ref(false); // 防重复提交
    const monthlyFormOrder = ref({
      id: "",
      openDate: "",
      openMonth: "",
      openCharge: "",

      // parkings: [],
    });
    const rentMonthRules = ref({
      openDate: [
        {
          required: true,
          trigger: ["blur", "change"],
          message: "请选择开通日期",
        },
      ],
      openMonth: [
        { required: true, message: "请填写开通月数", trigger: "blur" },
        { type: "number", message: "续费月数必须为数字值", trigger: "blur" },
        {
          type: "number",
          min: 1,
          message: "续费月数必须大于0",
          trigger: "blur",
        },
      ],
      openCharge: [
        {
          required: true,
          message: "请选择收费规则",
          trigger: ["blur", "change"],
        },
      ],
      // parkings: [
      //   {
      //     required: true,
      //     message: "请选择道路",
      //     trigger: ["blur", "change"],
      //   },
      // ],
    });

    // 会员卡信息（由入口页随 query 传入，用于顶部展示）
    const memberCard = ref({
      plateNumber: "",
      userName: "",
      phone: "",
      chargeName: "",
      startDate: "",
      endDate: "",
    });
    // 当前选中的收费规则
    const currentChargeRule = computed(() => {
      const rules = allMonthlyChargeRuleData.value || [];
      return (
        rules.find((r) => r.id === monthlyFormOrder.value.openCharge) || null
      );
    });
    // 应缴金额：续费月数 x 规则单价（与提交同源算法）
    const renewMoney = computed(() => {
      const rule = currentChargeRule.value;
      const months = Number(monthlyFormOrder.value.openMonth);
      if (!rule || !months || months < 1) return null;
      return currency(months).multiply(rule.amount).value; // currency 实例转数字（元）
    });
    function formatUnitType(unitType) {
      if (unitType == 2) return "年卡";
      if (unitType == 1) return "月卡";
      return "—";
    }

    function getAllMonthlyChargeRule(id) {
      this.$get(allMonthlyChargeRule(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) return;
        this.allMonthlyChargeRuleData = data.data;
      });
    }
    // 下单停车场范围：以当前选中收费规则配置的「可停用车场 parkingIds」为准
    function getOrderParkingIds() {
      const rule = this.currentChargeRule;
      const ids = rule?.parkingIds;
      if (ids === null || ids === undefined || ids === "") return [];
      if (Array.isArray(ids)) {
        return ids
          .map(String)
          .filter((s) => s && s.toLowerCase() !== "null");
      }
      return String(ids)
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s && s.toLowerCase() !== "null");
    }
    function valiForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(function(valid, noStri) {
          if (valid) {
            resolve({ status: true });
          } else {
            reject({ status: false, msg: "表单验证失败" });
          }
        });
      });
    }
    function onGoBackbtn() {
      this.$router.go(-1);
    }
    async function onCashBtn() {
      if (this.submitting) return; // 防重复提交
      try {
        await this.valiForm("rentMonthForm");
        const money = this.renewMoney; // 与页面展示金额同源
        if (money === null) {
          this.$message({
            type: "warning",
            message: "未找到对应收费规则或续费月数无效",
          });
          return;
        }
        await this.$confirm(`现金缴费金额为${money.toFixed(2)}元,确认缴费请按确定。`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const parkingIds = this.getOrderParkingIds();
        // if (!parkingIds.length) {
        //   this.$message({
        //     type: "warning",
        //     message: "对应收费规则未找到可停用车场，无法下单",
        //   });
        //   return;
        // }
        this.submitting = true;
        const payload = {
          id: this.recordId,
          months: this.monthlyFormOrder.openMonth,
          startTime: this.monthlyFormOrder.openDate,
          chargeRuleId: this.monthlyFormOrder.openCharge,
          cashAmount: money,
          operationType: "cash",
        };
        // parkingIds 为空时不携带该参数，交由后端校验并返回错误信息
        if (parkingIds.length) payload.parkingIds = parkingIds;
        const monthlyData = await this.$postRequest(monthlyUserAddOrEdit(), payload);
        if (monthlyData?.status == 200) {
          this.$message({ message: "缴费成功", type: "success" });
          this.$refs.rentMonthForm.resetFields(); // 成功后重置表单，防止重复提交同单
        } else {
          this.$message({
            type: "warning",
            message: monthlyData?.message || "缴费失败",
          });
        }
      } catch (err) {
        if (err === "cancel" || err?.msg === "cancel") return; // 用户取消确认框，静默返回
        this.$message({
          type: "warning",
          message: err?.msg || err,
        });
      } finally {
        this.submitting = false;
      }
    }
    async function onQrcodeBtn() {
      if (this.submitting) return; // 防重复提交
      try {
        await this.valiForm("rentMonthForm");
        const money = this.renewMoney; // 与页面展示金额同源
        if (money === null) {
          this.$message({
            type: "warning",
            message: "未找到对应收费规则或续费月数无效",
          });
          return;
        }
        this.monthlyMoney = money; // currency 实例转数字（元）
        const parkingIds = this.getOrderParkingIds();
        // if (!parkingIds.length) {
        //   this.$message({
        //     type: "warning",
        //     message: "对应收费规则未找到可停用车场，无法下单",
        //   });
        //   return;
        // }
        this.submitting = true;
        const payload = {
          id: this.recordId,
          months: this.monthlyFormOrder.openMonth,
          startTime: this.monthlyFormOrder.openDate,
          chargeRuleId: this.monthlyFormOrder.openCharge,
          cashAmount: this.monthlyMoney,
          operationType: "wechat",
        };
        // parkingIds 为空时不携带该参数，交由后端校验并返回错误信息
        if (parkingIds.length) payload.parkingIds = parkingIds;
        const monthlyData = await this.$postRequest(monthlyUserAddOrEdit(), payload);
        if (monthlyData?.status != 200) {
          this.$message({
            type: "warning",
            message: monthlyData?.message || "下单失败，请重试",
          });
          return;
        }
        // 兜底校验：后端在微信下单失败时可能返回 null/""/"null"，此时不展示二维码
        const qrUrl = monthlyData?.data;
        const qrUrlInvalid =
          qrUrl === null ||
          qrUrl === undefined ||
          qrUrl === "" ||
          String(qrUrl).trim().toLowerCase() === "null";
        if (qrUrlInvalid) {
          this.$message({
            type: "warning",
            message:
              monthlyData?.message || "获取付款二维码失败，请稍后重试",
          });
          return;
        }
        this.photoDialogVisible = true;
        this.$nextTick(() => {
          document.getElementById("qrcode").innerHTML = "";
          this.qrcode(qrUrl);
        });
      } catch (err) {
        if (err === "cancel" || err?.msg === "cancel") return; // 用户取消确认框，静默返回
        this.$message({
          type: "warning",
          message: err?.msg || err,
        });
      } finally {
        this.submitting = false;
      }
    }
    function qrcode(url) {
      if (!this.qrcodeInstance) {
        this.qrcodeInstance = new QRCode("qrcode", {
          width: 360,
          height: 360,
          colorDark: "#000",
          colorLight: "#fff",
        });
      }
      this.qrcodeInstance.clear(); // 清除二维码
      this.qrcodeInstance.makeCode(url); // 生成另一个新的二维码
    }
    return {
      recordId,
      memberCard,
      monthlyFormOrder,
      rentMonthRules,
      allMonthlyChargeRuleData,
      currentChargeRule,
      renewMoney,
      parkingsDataByProperty,
      photoDialogVisible,
      monthlyMoney,
      submitting,
      formatUnitType,
      onCashBtn,
      onQrcodeBtn,
      onGoBackbtn,
      valiForm,
      qrcode,
      getAllMonthlyChargeRule,
      getOrderParkingIds,
    };
  },
});
</script>
<style scoped>
.monthly-car-renewal {
  width: 100%;
  height: calc(100vh - 75px); /* 与 order-detail 一致，保证滚动生效 */
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 整页不再滚动，滚动收敛到中部正文区 */
}
/* 返回按钮：固定在顶部，且与正文内容左对齐（宽 80% 居中） */
.go-back {
  flex-shrink: 0;
  width: 80%;
  margin: 0 auto 16px;
  font-size: 20px;
  cursor: pointer;
}
/* 中部滚动区：min-height: 0 是 flex 子项滚动生效的关键 */
.monthly-car-renewal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
/* 正文内容宽度沿用原 80% 居中 */
.monthly-car-renewal-content {
  width: 80%;
  margin: 0 auto;
}
.monthly-car-renewal-form {
  width: 100%;
}
/* 底部固定操作栏：与正文同宽，顶部加分隔线增强“固定栏”视觉 */
.renewal-footer {
  flex-shrink: 0;
  width: 80%;
  margin: 20px auto 0;
  border-top: 1px solid #ebeef5;
  padding-top: 16px;
  box-sizing: border-box;
}
.buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 12px;
}
.cash-button {
  height: 50px;
  width: 30%;
  font-size: 20px;
  font-weight: bold;
}
.qrcode-button {
  height: 50px;
  width: 30%;
  font-size: 20px;
  font-weight: bold;
}
.renewal-card {
  width: 100%;
  background: #f7f8fa;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 24px;
  box-sizing: border-box;
}
.renewal-card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}
.renewal-card-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.renewal-card-grid li {
  width: 33.33%;
  display: flex;
  align-items: flex-start;
  margin: 6px 0;
  padding: 0 8px;
  box-sizing: border-box;
}
.renewal-card-grid li.renewal-card-full {
  width: 100%;
}
.renewal-card-label {
  flex-shrink: 0;
  color: #909399;
  margin-right: 8px;
}
.renewal-card-value {
  color: #303133;
  word-break: break-all;
}
.renew-money {
  margin-top: 8px;
  margin-bottom: 8px;
  text-align: center;
}
.renew-money-label {
  font-size: 18px;
  color: #303133;
}
.renew-money-value {
  font-size: 34px;
  font-weight: bold;
  color: #f56c6c;
  margin-left: 10px;
}
</style>
<style>
.monthly-car-renewal .el-form-item {
  height: 50px;
  margin-top: 40px;
}
.monthly-car-renewal .el-form-item__content {
  height: 100%;
}
.monthly-car-renewal .el-date-editor.el-input,
.monthly-car-renewal .el-date-editor.el-input__inner {
  width: 100%;
  max-width: 100%;
  height: 100%;
}
.monthly-car-renewal .el-select {
  width: 100%;
  max-width: 100%;
}
.monthly-car-renewal .el-input__inner,
.monthly-car-renewal .el-input,
.monthly-car-renewal .el-select {
  height: 100%;
  border-radius: 10px;
}
.qrcode-money {
  font-size: 40px;
  text-align: center;
  font-weight: bold;
}
</style>
